/**
 * Sa.Reseller.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CompanyNameOriginEnum = 'Company' | 'CompanyProfile' | 'AlternativeName';

export const CompanyNameOriginEnum = {
    Company: 'Company' as CompanyNameOriginEnum,
    CompanyProfile: 'CompanyProfile' as CompanyNameOriginEnum,
    AlternativeName: 'AlternativeName' as CompanyNameOriginEnum
};

